import _ from 'lodash';

class PeriodListController {
  constructor($scope, $translate) {
    'ngInject';
    this.scope = $scope;
    this.translate = $translate;
    this.hoverDate = 100;
    this.viewAll = false;
  }

  $onInit() {
    this.hasEventsToShow();

    this.scope.$watch(() => this.events, () => {
      this.hasEventsToShow();
    });

    this.currentList = document.querySelector('.period-list');
    this._translate();

    if (!this.isMobileApp) {
      this.scope.$on('period-hover-in', _.debounce(() => {
        this.scrollToElement();
      }, 500, {
        maxWait: 2000,
      }));

      this.scope.$watch(() => this.format, () => {
        this.setFormat();
      });
    }
  }

  $postLink() {
    if (!this.isMobileApp) {
      this.makeMeSticky();
    }
  }

  setFormat() {
    this.format === 'tablet' ? $('.period-list').addClass('tablet') : $('.period-list').removeClass('tablet');
  }

  _translate() {
    this.translate('GLOBALS.BUTTON_ACTION.VIEW_MORE').then((translation) => {
      this.VIEW_MORE = translation;
    });
    this.translate('GLOBALS.BUTTON_ACTION.VIEW_LESS').then((translation) => {
      this.VIEW_LESS = translation;
    });
    this.translate('VACATIONS_ABSENCES.GENERAL.AGREEMENT').then((translation) => {
      this.AGREEMENT = translation;
    });
    this.translate('VACATIONS_ABSENCES.GENERAL.FREE').then((translation) => {
      this.FREE = translation;
    });
    this.translate('VACATIONS_ABSENCES.GENERAL.CHRISTMAS').then((translation) => {
      this.CHRISTMAS = translation;
    });
    this.translate('GLOBALS.DAYS').then((translation) => {
      this.DIAS = translation;
    });
  }

  scrollToElement() {
    let list = $('.period-list .period-list-body');
    let card = $('.period-card.hover');
    let cardOffset = card.offset();
    if (!cardOffset) return;
    list.animate({
      scrollTop: card.offset().top - list.offset().top + list.scrollTop(),
    }, 500);
  }

  makeMeSticky() {
    let list = document.querySelector('.sticky-sidebar');

    if (!list) return;

    let menuPosition = list.getBoundingClientRect();
    let placeholder = document.createElement('listPlaceholder');
    placeholder.style.width = menuPosition.width + 'px';
    placeholder.style.height = menuPosition.height + 'px';
    let isAdded = false;

    window.addEventListener('scroll',  () => {
      if (window.pageYOffset >= menuPosition.top && !isAdded && !this.viewAll) {
        list.classList.add('sticky');
        list.parentNode.insertBefore(placeholder, list);
        isAdded = true;
      } else if (window.pageYOffset < menuPosition.top && isAdded) {
        list.classList.remove('sticky');
        list.parentNode.removeChild(placeholder);
        isAdded = false;
      }
    });
  }

  hasEventsToShow() {
    this.isHolidayAbsenceEvents = this.events.some(event => {
      return event.type !== 'holiday';
    });
  }
}
export default PeriodListController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodList.controller.js